import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Button as ShadcnButton, Card, CardContent, Alert as UiAlert, AlertDescription, Collapsible, CollapsibleTrigger, CollapsibleContent, } from '@cargomatic/ui';
import CargomaticCollapsibleCard from 'components/v2/CollapsibleCard';
import { AlertCircle, ChevronDown, MapPin, EyeOff } from 'lucide-react';
import AuditHistory from 'components/modules/shipments/AuditHistory';
import EditReferenceNumbersModal from 'components/modules/shipments/EditReferenceNumbersModal';
import DataPoller from 'components/ui/DataPoller';
import ArrivedModal from 'components/ui/tailwind/modals/ArrivedModal';
import OrderShipmentsStore from 'stores/OrderShipmentsStore';
import { withTranslation } from 'react-i18next';
import OrdersActionCreators from '../../../actions/OrdersActionCreators';
import OrdersStore from '../../../stores/OrdersStore';
import SessionStore from '../../../stores/SessionStore';
import StatusBar from './StatusBar';
import OrderMap from './OrderMap';
import { OrderDocuments } from './OrderDocuments';
import CommentList from '../comments/CommentList';
import InboundDetails from './OrderDetails';
import ReferenceNumbers from './ReferenceNumbers';
import { OrderShipments } from './leg-management';
import ShipmentsList from './ShipmentsList';
import EquipmentsList from './EquipmentsList';
import AccountsPayable from './AccountsPayable';
import AccountsReceivable from './AccountsReceivable';
import AccessorialsList from './AccessorialsList';
import BulkAddAccessorialsModal from '../shipments/accounting/BulkAddAccessorialsModal';
import OrderRtbSummary from 'components/modules/orders/order-rtb/OrderRtbSummary';
import { isDrayageShipment } from '../../../helpers/shipment-types';
import { isLegManagementEnabled } from '../../../helpers/legs-helper';
import HazmatDetails from './HazmatDetailsList';
const POLLING_FREQ = 30000;
const shipmentQueryOptions = {
    paginate: true,
    per_page: 25,
    page: 1,
};
class Module extends Component {
    constructor(props) {
        super(props);
        this.handleOrderShipmentsStoreChange = () => {
            const orderShipments = OrderShipmentsStore.getOrderShipments();
            this.updateShipmentsState(orderShipments);
        };
        this.handleOrdersStoreChange = () => {
            const order = OrdersStore.getOrder();
            const audits = OrdersStore.getAudits();
            if (!this.state.title && order && order.order_id) {
                document.title = order.order_id;
                this.setState({ title: order.order_id });
            }
            const shipmentsWithZeroValueAccessorials = this.getShipmentsWithZeroValueAccessorials(order);
            this.setState({
                order,
                shipmentsWithZeroValueAccessorials,
                hasZeroValueAccessorials: shipmentsWithZeroValueAccessorials.length > 0,
                audits,
            });
        };
        this.handleStagingShipmentsChange = () => {
            const stagingShipments = OrdersStore.getStagingShipments();
            if (!stagingShipments) {
                return;
            }
            this.setState({ stagingShipments });
        };
        this.handleCommentAdd = (comment) => {
            const { order: { _id: orderId }, } = this.state;
            OrdersActionCreators.addComment(orderId, comment);
        };
        this.handleAddBulkAccessorialsClick = () => this.setState({ showBulkAddAccessorialsModal: true });
        this.handleSessionStoreChange = () => {
            const hasFinanceRole = SessionStore.hasFinanceRole();
            this.setState({
                hasFinanceRole,
            });
        };
        this.onGetOrderShipments = () => {
            const orderId = this.props.id || this.props.match.params.id;
            const options = Object.assign(Object.assign({}, shipmentQueryOptions), { page: this.state.shipmentListPagination.currentPage || 1 });
            OrdersActionCreators.getOrderShipments(orderId, options);
        };
        this.handleShipmentListPagination = (eventKey) => {
            const paginationData = OrderShipmentsStore.getOrderShipmentPaginationData();
            this.setState({
                shipmentListPagination: {
                    currentPage: eventKey,
                    totalPages: paginationData.pages,
                },
            }, this.onGetOrderShipments);
        };
        const hasFinanceRole = SessionStore.hasFinanceRole();
        this.state = {
            order: null,
            title: '',
            shipmentsWithZeroValueAccessorials: [],
            audits: [],
            showEditReferenceNumbersModal: false,
            showArrivedModal: false,
            showBulkAddAccessorialsModal: false,
            showMap: true,
            hasFinanceRole,
            stagingShipments: [],
            bookedShipments: [],
            shipmentListPagination: {},
        };
    }
    componentDidMount() {
        OrdersActionCreators.getOrderShipments(this.props.id || this.props.match.params.id, shipmentQueryOptions);
        OrderShipmentsStore.addChangeListener(this.handleOrderShipmentsStoreChange);
        OrdersStore.addStagingShipmentsChangeListener(this.handleStagingShipmentsChange);
        OrdersStore.addChangeListener(this.handleOrdersStoreChange);
        SessionStore.addChangeListener(this.handleSessionStoreChange);
        this.handleStagingShipmentsChange();
    }
    componentWillUnmount() {
        OrdersStore.removeChangeListener(this.handleOrdersStoreChange);
        SessionStore.removeChangeListener(this.handleSessionStoreChange);
        OrdersActionCreators.resetStagingShipments();
        OrdersActionCreators.resetOrderShipments();
    }
    getOrder() {
        const { order } = this.state;
        return order || {};
    }
    getShipments() {
        return this.state.bookedShipments || [];
    }
    getShipmentsWithZeroValueAccessorials(order) {
        if (!order) {
            return [];
        }
        const orderShipments = this.state.bookedShipments || [];
        return orderShipments.filter((job) => {
            const receivables = job.receivables || [];
            const payables = job.payables || [];
            const zeroCostAR = receivables.filter((s) => s.value === 0);
            const zeroCostAP = payables.filter((s) => s.value === 0);
            return zeroCostAR.length > 0 || zeroCostAP > 0;
        });
    }
    updateReferenceNumbers(references) {
        OrdersActionCreators.updateOrder(this.state.order._id, {
            reference_numbers: references,
        });
        this.setState({
            showEditReferenceNumbersModal: false,
        });
    }
    updateOrderHazmatDetails(orderId, hazmatDetails) {
        OrdersActionCreators.updateOrder(orderId, {
            hazmat_details: hazmatDetails,
        });
    }
    renderMissingDocumentation() {
        const drayageShipmentsMissingDocumentation = this.getShipments().filter((s) => isDrayageShipment(s) && s.missing_docs);
        if (this.state.order &&
            !this.state.order.missing_docs &&
            drayageShipmentsMissingDocumentation.length === 0)
            return null;
        const { t } = this.props;
        return (React.createElement(UiAlert, { variant: "destructive", className: "mb-4", "data-testid": "Alert-564a51e7" },
            React.createElement(AlertCircle, { className: "h-4 w-4" }),
            React.createElement(AlertDescription, null, t('MISSING_DOC_FOR_ORDER'))));
    }
    renderOutstandingARStatus() {
        const { order: { outstanding_ar, outstanding_ap }, } = this.state;
        if (!outstanding_ar && !outstanding_ap) {
            return null;
        }
        const { t } = this.props;
        return (React.createElement(UiAlert, { className: "mb-4", "data-testid": "Alert-29539371" },
            React.createElement(AlertCircle, { className: "h-4 w-4" }),
            React.createElement(AlertDescription, null, t('OUTSTANDING_BALANCE_FOR_ORDER'))));
    }
    renderZeroBalanceNotification() {
        if (!this.state.hasZeroValueAccessorials) {
            return null;
        }
        const { shipmentsWithZeroValueAccessorials: jobs } = this.state;
        const { t } = this.props;
        return (React.createElement(Collapsible, { defaultOpen: true, className: "mb-4", "data-testid": "Alert-8cebe271" },
            React.createElement(UiAlert, null,
                React.createElement(AlertCircle, { className: "h-4 w-4" }),
                React.createElement(AlertDescription, { className: "flex items-center justify-between w-full" },
                    React.createElement("span", null, t('NO_ACCESSORIAL_RATE_OR_COST_FOR_SHIPMENT')),
                    React.createElement(CollapsibleTrigger, { className: "ml-2 hover:bg-muted rounded p-1" },
                        React.createElement(ChevronDown, { className: "h-4 w-4" })))),
            React.createElement(CollapsibleContent, null,
                React.createElement("div", { className: "border border-t-0 rounded-b-lg px-4 py-2 space-y-1" }, jobs.map((job) => {
                    const jobLink = `/shipments/${job._id}`;
                    return (React.createElement("a", { key: job._id, href: jobLink, className: "block text-sm text-primary hover:underline" }, job.shipment_id));
                })))));
    }
    getShipmentsEligibleForAccessorialsManagement() {
        return this.getShipments().filter((s) => {
            return !_.isEmpty(s.carrier);
        });
    }
    updateShipmentsState(bookedShipments) {
        this.setState((prevState) => {
            const { stagingShipments, shipmentListPagination: currentPagination } = prevState;
            const shipments = [...stagingShipments, ...bookedShipments];
            const pagination = OrderShipmentsStore.getOrderShipmentPaginationData();
            const shipmentListPagination = {
                totalPages: pagination.pages,
                currentPage: currentPagination.currentPage || 1,
            };
            return {
                bookedShipments,
                shipments,
                shipmentListPagination,
            };
        });
    }
    render() {
        const { order, bookedShipments, stagingShipments } = this.state;
        const id = this.props.id || this.props.match.params.id;
        const { hideMap, renderedInModal, t } = this.props;
        return (React.createElement("div", { "data-testid": "div-95433961", className: "px-4 sm:px-6" },
            React.createElement(DataPoller, { dataTestId: "DataPoller-143d43d3", action: () => OrdersActionCreators.getOrder(id), frequency: POLLING_FREQ }),
            React.createElement(DataPoller, { dataTestId: "DataPoller-cd654e78", action: () => OrdersActionCreators.getOrderAudits(id), frequency: POLLING_FREQ }),
            React.createElement(DataPoller, { dataTestId: "DataPoller-af62a7e5", action: this.onGetOrderShipments, frequency: POLLING_FREQ }),
            order && order._id && (React.createElement("div", { "data-testid": "div-889d6180", id: "order-details-container" },
                this.renderMissingDocumentation(),
                this.renderOutstandingARStatus(),
                this.renderZeroBalanceNotification(),
                React.createElement(Card, null,
                    React.createElement(CardContent, { className: "p-0" },
                        React.createElement(StatusBar, { order: order, shipments: bookedShipments, onArrivedClick: () => this.setState({ showArrivedModal: true }) }),
                        !hideMap && (React.createElement("div", null,
                            React.createElement("div", { className: "flex justify-end px-4 py-2" },
                                React.createElement(ShadcnButton, { variant: "ghost", size: "sm", onClick: () => this.setState({
                                        showMap: !this.state.showMap,
                                    }) },
                                    this.state.showMap ? (React.createElement(EyeOff, { className: "w-4 h-4 mr-1" })) : (React.createElement(MapPin, { className: "w-4 h-4 mr-1" })),
                                    this.state.showMap ? 'Hide Map' : 'Show Map')),
                            this.state.showMap && (React.createElement("div", { "data-testid": "div-9c2d5406" },
                                React.createElement(OrderMap, { arriving: order.arriving, delivering: order.delivering }))))))),
                React.createElement("div", { "data-testid": "div-f11b63c0", className: "mt-5 grid gap-y-6 sm:grid-cols-12 sm:gap-6" },
                    React.createElement("div", { "data-testid": "div-9f2bf684", className: "sm:col-span-4 min-w-0" },
                        React.createElement(InboundDetails, { order: order, onEdit: (edit) => {
                                OrdersActionCreators.updateOrder(order._id, edit);
                            } })),
                    React.createElement("div", { "data-testid": "div-f6319b88", className: "sm:col-span-4 min-w-0" },
                        React.createElement(ReferenceNumbers, { order: order, onEdit: () => {
                                this.setState({ showEditReferenceNumbersModal: true });
                            } })),
                    React.createElement("div", { "data-testid": "div-d2d86e6e", className: "sm:col-span-4 space-y-6 min-w-0" },
                        React.createElement(OrderDocuments, { order: order, shipments: bookedShipments }),
                        React.createElement(CargomaticCollapsibleCard, { id: "order-notes", header: () => React.createElement("span", null, t('NOTE', { count: 2 })) },
                            React.createElement(CommentList, { comments: order.comments, onCommentAdd: this.handleCommentAdd })))),
                React.createElement("div", { "data-testid": "div-a7e55760", className: "my-6" },
                    React.createElement(HazmatDetails, { order: order, updateOrderHazmatDetails: this.updateOrderHazmatDetails, isEditable: true })),
                React.createElement("div", { "data-testid": "div-a7e55759", className: "my-6" },
                    React.createElement(EquipmentsList, { order: order, shipments: bookedShipments })),
                isLegManagementEnabled(order) && (React.createElement(OrderShipments, { orderId: id, order: order })),
                !isLegManagementEnabled(order) && (React.createElement(ShipmentsList, { order: order, bookedShipments: bookedShipments, stagingShipments: stagingShipments, renderedInModal: renderedInModal, onGetPaginatedShipments: this.handleShipmentListPagination, paginationData: this.state.shipmentListPagination })),
                isLegManagementEnabled(order) && (React.createElement("div", { className: "my-6" },
                    React.createElement(OrderRtbSummary, { orderId: order === null || order === void 0 ? void 0 : order._id, order: order, shipments: bookedShipments }))),
                !isLegManagementEnabled(order) && (React.createElement("div", { "data-testid": "div-99fac929", className: "my-6 grid gap-y-6 sm:grid-cols-2 sm:gap-x-4" },
                    React.createElement("div", { "data-testid": "div-1067acea", className: "sm:col-span-1 min-w-0" },
                        React.createElement(AccountsReceivable, { order: order, shipments: bookedShipments })),
                    React.createElement("div", { "data-testid": "div-d143ceed", className: "sm:col-span-1 min-w-0" },
                        React.createElement(AccountsPayable, { order: order, shipments: bookedShipments })),
                    this.state.hasFinanceRole && (React.createElement("div", { "data-testid": "div-c12fb1a8", className: "sm:col-span-2 min-w-0" },
                        React.createElement(AccessorialsList, { order: order, shipments: bookedShipments, onAddBulkAccessorials: this.handleAddBulkAccessorialsClick }))))),
                React.createElement("div", { className: "my-6" },
                    React.createElement(CargomaticCollapsibleCard, { id: "order-audit-history", header: () => React.createElement("span", null, t('AUDIT_HISTORY')) },
                        React.createElement(AuditHistory, { audits: this.state.audits }))))),
            (order === null || order === void 0 ? void 0 : order.reference_numbers) && (React.createElement(EditReferenceNumbersModal, { reference_numbers: order.reference_numbers, shipper: order.shipper, isIntermodalShipmentType: true, page: "Orders", show: this.state.showEditReferenceNumbersModal, onSave: (references) => this.updateReferenceNumbers(references), onClose: () => {
                    this.setState({ showEditReferenceNumbersModal: false });
                } })),
            this.state.showArrivedModal && (React.createElement(ArrivedModal, { dataTestId: "ArrivedModal-c00242a0", show: this.state.showArrivedModal, onComplete: (workflow, meta) => {
                    OrdersActionCreators.transitionOrder(order, workflow, meta);
                }, onHide: () => this.setState({ showArrivedModal: false }) })),
            !isLegManagementEnabled(order) &&
                this.state.showBulkAddAccessorialsModal && (React.createElement(BulkAddAccessorialsModal, { show: this.state.showBulkAddAccessorialsModal, orderId: this.getOrder()._id, shipmentIds: this.getShipmentsEligibleForAccessorialsManagement().map((s) => s._id), onSave: this.handleBulkCreateAccessorials, onHide: () => {
                    this.setState({ showBulkAddAccessorialsModal: false });
                }, edit: false })),
            React.createElement("div", { "data-testid": "div-1d32f7ce", style: { height: 400 } }, "\u00A0")));
    }
}
Module.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    renderedInModal: PropTypes.bool,
};
export default withTranslation()(Module);
